import { app } from '../../../../../app';
import { Controller } from './delete-accounts.controller';

app.component('companySharingCenterSharedPasswordsDelete', {
    bindings: {
        accounts: '<',
        companyId: '<'
    },
    controller: Controller,
    templateUrl: require('./delete-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/delete/delete-accounts.component.js